<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-3">
        How many moles of glucose,
        <chemical-latex content="C6H12O6," />
        are present in a
        <number-value :value="mass" unit="\text{g}" />
        sample of glucose?
      </p>

      <calculation-input
        v-model="inputs.studentAnswer"
        prepend-text="$\text{Glucose:}$"
        append-text="$\text{mol}$"
        :disabled="!allowEditing"
      />
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import CalculationInput from '../inputs/CalculationInput';
import NumberValue from '../NumberValue';
import StembleLatex from '@/tasks/components/StembleLatex';
import ChemicalLatex from '@/tasks/components/displayers/ChemicalLatex.vue';

export default {
  name: 'ChemSIU131_Task8',
  components: {
    ChemicalLatex,
    CalculationInput,
    NumberValue,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        studentAnswer: null,
      },
    };
  },
  computed: {
    mass() {
      return this.taskState.getValueBySymbol('mass').content;
    },
  },
};
</script>
